import { isEmpty } from "lodash/fp";

import { httpDelete, patch, post } from "@readai/common/api";
import { User } from "@readai/common/types";
import type {
  EnterpriseWorkspace,
  PatchEnterpriseUserBody,
} from "@readai/common/types/workspaceTypes";

// Migrates the specified user's meetings to the specified workspace
export const migrateMeetings = async (
  workspaceId: string,
  userId: string,
): Promise<void> =>
  post(
    `/enterprise/workspaces/${workspaceId}/users/${userId}/import_sessions`,
    {},
    { withCreds: true },
  );

export const updateWorkspaceUser = async (
  workspaceId: string,
  user: PatchEnterpriseUserBody,
): Promise<void> => {
  const { userId } = user;
  return patch(`/enterprise/workspaces/${workspaceId}/users/${userId}`, user, {
    withCreds: true,
  });
};

export const deleteWorkspaceUser = async (
  workspaceId: EnterpriseWorkspace["id"],
  userId: User["id"],
): Promise<void> => {
  return httpDelete(`/enterprise/workspaces/${workspaceId}/users/${userId}`, {
    withCreds: true,
  });
};

export const deleteWorkspaceUsers = async (
  workspaceId: string,
  userIds: string[],
): Promise<void> => {
  if (isEmpty(userIds)) return;

  const body = userIds.map((userId) => ({ userId }));
  return post(`/enterprise/workspaces/${workspaceId}/users/bulk-delete`, body, {
    withCreds: true,
  });
};
